const baseUrl = "https://ai-api.investobull.com/api/ai/admin/docs";

const getHeaders = () => {
  return {};
};

const buildQueryString = (params) => {
  if (!params) return "";
  const query = [];
  if (params.from) query.push(`from=${encodeURIComponent(params.from)}`);
  if (params.to) query.push(`to=${encodeURIComponent(params.to)}`);
  if (params.page !== undefined && params.page !== null && params.page !== "") {
    query.push(`page=${encodeURIComponent(params.page)}`);
  }
  if (params.size !== undefined && params.size !== null && params.size !== "") {
    query.push(`size=${encodeURIComponent(params.size)}`);
  }
  if (params.documentType && params.documentType !== "ALL") {
    query.push(`documentType=${encodeURIComponent(params.documentType)}`);
  }
  return query.length > 0 ? "?" + query.join("&") : "";
};

export const getDbStats = async (params) => {
  const qs = buildQueryString(params);
  const url = `${baseUrl}/db-stats${qs}`;
  try {
    const response = await fetch(url, { method: "GET", headers: getHeaders() });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return { status: true, data };
  } catch (error) {
    return { status: false, error: error.message || error };
  }
};

export const getDbSummary = async (params) => {
  const qs = buildQueryString(params);
  const url = `${baseUrl}/db-stats/summary${qs}`;
  try {
    const response = await fetch(url, { method: "GET", headers: getHeaders() });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return { status: true, data };
  } catch (error) {
    return { status: false, error: error.message || error };
  }
};

export const getFileStats = async (params) => {
  const qs = buildQueryString(params);
  const url = `${baseUrl}/stats${qs}`;
  try {
    const response = await fetch(url, { method: "GET", headers: getHeaders() });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return { status: true, data };
  } catch (error) {
    return { status: false, error: error.message || error };
  }
};

export const getFileSummary = async (params) => {
  const qs = buildQueryString(params);
  const url = `${baseUrl}/stats/summary${qs}`;
  try {
    const response = await fetch(url, { method: "GET", headers: getHeaders() });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return { status: true, data };
  } catch (error) {
    return { status: false, error: error.message || error };
  }
};
